// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"3068d973","530":"c859f9e1"}[chunkId] + ".chunk.css";
};